import { BpLink } from '../../../../shared/components/text/link/BpLink'
import React from 'react'

interface TopAdvertiserCellProps {
  top_advertiser: string
  project_id: number | string
}

export const TopAdvertiserCell = ({ top_advertiser, project_id }: TopAdvertiserCellProps) => {
  return <BpLink to={`ads-domain/${project_id}/${top_advertiser}`}>{top_advertiser}</BpLink>
}
